// 1.5 = legacy single-line embroidery; 2.0 = multi-placement (one line per attachment).
export const EMBROIDERY_VERSION_V1 = '1.5'
export const EMBROIDERY_VERSION_V2 = '2.0'

export type EmbroideryVersion = typeof EMBROIDERY_VERSION_V1 | typeof EMBROIDERY_VERSION_V2
